module.exports = __webpack_public_path__ + "static/media/apple-icon.4ad3d6da.png";